import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginLayoutComponent } from './login-layout/login-layout.component';

@NgModule({
  declarations: [LoginLayoutComponent],
  exports: [LoginLayoutComponent],
  imports: [
    CommonModule,
  ],
})
export class LayoutModule { }
